import axios from 'axios';

import {BASE_URL} from '@/utils/config';
import {axiosPublic} from "@/service/axios";

const URL = BASE_URL;

export const sendAssistanceRequest = async (data) => {
	try {
		const response = await axios.post(`${URL}/account/send-assistance-request`, data);
		console.log("(accountApis.js) Send Assistance Request Response: ", response);
		return response.data;
	} catch (error) {
		console.error("(accountApis.js) Error occurred while sending assistance request: ", error);
	}
}

export const fetchFeatures = async () => {
	try {
		const response = await axios.get(`${URL}/account/features`);
		console.log("(accountApis.js) Fetch Features Response: ", response);

		return response.data;
	} catch (error) {
		console.log("(accountApis.js) Error occurred while fetching features: ", error);
	}
}

export const findProfiles = async (payload) => {
	// Public — uses axiosPublic, no auth token
	const response = await axiosPublic.post(`${URL}/account/find-profiles`, payload);
	return response.data;
};

export const sendProfileClaimOtp = async (payload) => {
	const response = await axiosPublic.post(`${URL}/account/send-profile-claim-otp`, payload);
	return response.data;
};

export const verifyProfileClaimOtp = async (payload) => {
	const response = await axiosPublic.post(`${URL}/account/verify-profile-claim-otp`, payload, {withCredentials: true});
	return response.data;
};

export const submitProfileClaimRequest = async (payload) => {
	const response = await axiosPublic.post(`${URL}/account/claim-request`, payload);
	return response.data;
};

export const getMatchingProfiles = async (account) => {
	try {
		const response = await axios.post(`${URL}/account/get-matching-profiles`, account);
		if (response.status === 409) {
			return null;
		}
		return response.data;
	} catch (error) {
		console.error(error);
	}
}

export const addAccount = async (axiosInstance, account) => {
	try {
		const response = await axiosInstance.post(`${URL}/account/signup`, account);
		if (response.status === 409) {
			return null;
		}
		return response.data;
	} catch (error) {
		console.error(error);
	}
}

export const addAccountAndNode = async (account) => {
	try {
		const response = await axios.post(`${URL}/account/add-account-and-node`, account);
		console.log("Add Account and Node Response: ", response);
		if (response.status === 409) {
			return null;
		}
		return response.data;
	} catch (error) {
		console.error(error);
	}
}

export const getAccount = async (data) => {
	try {
		const response = await axios.get(`${URL}/account/login`, {params: data});
		if (response.status === 200) {
			return response.data;
		}
		return null;
	} catch (error) {
		console.error(error);
	}
}

export const updateAccountById = async (axiosInstance, id, updatedAccountDetails) => {
	try {
		const response = await axiosInstance.put(`${URL}/account/update/${id}`, updatedAccountDetails);
		return response.data;
	} catch (error) {
		console.error(error);
	}
}

export const logoutFromAccount = async (axiosInstance) => {
	try {
		const response = await axiosInstance.get(`${URL}/auth/logout`);
		console.log("Logout Response: ", response);
		return response.data;
	} catch (error) {
		console.error("Error occurred while logging out: ", error);
	}
}

export const deleteAccount = async (accountId, nodeId) => {
	try {
		const response = await axios.put(`${URL}/account/delete`, {
			accountId: accountId,
			nodeId: nodeId
		});

		console.log("Delete Account Response: ", response);

		return response.data;
	} catch (error) {
		console.log("Error occurred while deleting account: ", error);
	}
}

export const getPincodeDetails = async (pincode, countryCode) => {
	try {
		const response = await axios.get(`${URL}/account/get-pincode-details`, {
			params: {
				pincode: pincode,
				countryCode: countryCode
			}
		});
		console.log("(accountApi.js) Get Pincode Details Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get Pincode Details Error: ", error);
	}
}

export const getFilteredUsers = async (filterData) => {
	try {
		const response = await axios.post(`${URL}/account/search`, filterData);
		console.log("(accountApi.js) Get Filtered Users Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get Filtered Users Error: ", error);
	}
}

export const getUsers = async (searchQuery) => {
	try {
		const response = await axios.get(`${URL}/account/search-users?query=${searchQuery}`);
		console.log("(accountApi.js) Get Users Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get Users Error: ", error);
	}
}

export const getUsersInFamilyTree = async (familyTreeId, searchQuery) => {
	try {
		const response = await axios.get(`${URL}/account/search-users-in-family-tree/${familyTreeId}?query=${searchQuery}`);
		console.log("(accountApi.js) Get Users in Family Tree Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get Users in Family Tree Error: ", error);
	}
}

export const getListOfFamilyTreesByLocation = async (location) => {
	try {
		const response = await axios.get(`${URL}/account/get-family-tree-list?query=${location}`);
		console.log("(accountApi.js) Get List of Family Tree by Location Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get List of Family Tree by Location Error: ", error);
		return error.response.data;
	}
}

export const addProfession = async (professionDetails) => {
	try {
		const response = await axios.post(`${URL}/account/add-profession`, professionDetails);
		console.log("(accountApi.js) Add Profession Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Add Profession Error: ", error);
	}
}

export const updateProfession = async (updatedDetails) => {
	try {
		const response = await axios.put(`${URL}/account/update-profession`, updatedDetails);
		console.log("(accountApi.js) Update Profession Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Update Profession Error: ", error);
	}
}

export const deleteProfession = async (data) => {
	try {
		const response = await axios.put(`${URL}/account/delete-profession`, data);
		console.log("(accountApi.js) Delete Profession Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Delete Profession Error: ", error);
	}
}

export const addEducation = async (educationDetails) => {
	try {
		const response = await axios.post(`${URL}/account/add-education`, educationDetails);
		console.log("(accountApi.js) Add Education Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Add Education Error: ", error);
	}
}

export const updateEducation = async (updatedDetails) => {
	try {
		const response = await axios.put(`${URL}/account/update-education`, updatedDetails);
		console.log("(accountApi.js) Update Education Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Update Education Error: ", error);
	}
}

export const deleteEducation = async (data) => {
	try {
		const response = await axios.put(`${URL}/account/delete-education`, data);
		console.log("(accountApi.js) Delete Education Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Delete Education Error: ", error);
	}
}

export const addAward = async (awardDetails) => {
	try {
		const response = await axios.post(`${URL}/account/add-award`, awardDetails);
		console.log("(accountApi.js) Add Award Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Add Award Error: ", error);
	}
}

export const updateAward = async (updatedDetails) => {
	try {
		const response = await axios.put(`${URL}/account/update-award`, updatedDetails);
		console.log("(accountApi.js) Update Award Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Update Award Error: ", error);
	}
}

export const deleteAward = async (data) => {
	try {
		const response = await axios.put(`${URL}/account/delete-award`, data);
		console.log("(accountApi.js) Delete Award Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Delete Award Error: ", error);
	}
}

export const addSocialMedia = async (socialMediaDetails) => {
	try {
		const response = await axios.post(`${URL}/account/add-social-media`, socialMediaDetails);
		console.log("(accountApi.js) Add Social Media Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Add Social Media Error: ", error);
	}
}

export const updateSocialMedia = async (updatedDetails) => {
	try {
		const response = await axios.put(`${URL}/account/update-social-media`, updatedDetails);
		console.log("(accountApi.js) Update Social Media Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Update Social Media Error: ", error);
	}
}

export const deleteSocialMedia = async (data) => {
	try {
		const response = await axios.put(`${URL}/account/delete-social-media`, data);
		console.log("(accountApi.js) Delete Social Media Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Delete Social Media Error: ", error);
	}
}

export const addMedicalCondition = async (languageKnownDetails) => {
	try {
		const response = await axios.post(`${URL}/account/add-medical-condition`, languageKnownDetails);
		console.log("(accountApi.js) Add Medical Condition Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Add Medical Condition Error: ", error);
	}
}

export const updateMedicalCondition = async (updatedDetails) => {
	try {
		const response = await axios.put(`${URL}/account/update-medical-condition`, updatedDetails);
		console.log("(accountApi.js) Update Medical Condition Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Update Medical Condition Error: ", error);
	}
}

export const deleteMedicalCondition = async (data) => {
	try {
		const response = await axios.put(`${URL}/account/delete-medical-condition`, data);
		console.log("(accountApi.js) Delete Medical Condition Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Delete Medical Condition Error: ", error);
	}
}

export const updateProfilePicture = async (updatePfpFormData) => {
	try {
		const response = await axios.post(`${URL}/account/update-pfp`, updatePfpFormData);
		console.log("(accountApi.js) Update Pfp Response: ", response);
		return response.data;
	} catch (error) {
		console.error(error);
	}
}

export const getUserById = async (axiosInstance, id) => {
	console.log("Starting getUserById request, axios instance:", !!axiosInstance);
	console.log("Request headers before:", axiosInstance.defaults.headers);

	try {
		const response = await axiosInstance.get(`/account/get-user-by-id/${id}`);
		console.log("(accountApi.js) Get User By Id Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Get User By Id Error: ", error);
	}
}

export const getUsersByDateOfBirth = async (dateOfBirth) => {
	try {
		const response = await axios.get(`${URL}/account/get-users-by-date-of-birth/${dateOfBirth}`);
		console.log("(accountApi.js) Get Users By Date of Birth Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Error while getting users by DOB: ", error);
	}
}

export const getUsersByDateOfMarriage = async (dateOfMarriage) => {
	try {
		const response = await axios.get(`${URL}/account/get-users-by-date-of-marriage/${dateOfMarriage}`);
		console.log("(accountApi.js) Get Users By Date of Marriage Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Error while getting users by DOM: ", error);
	}
}

export const getUsersByDateOfDeath = async (dateOfDeath) => {
	try {
		const response = await axios.get(`${URL}/account/get-users-by-date-of-death/${dateOfDeath}`);
		console.log("(accountApi.js) Get Users By Date of Death Response: ", response);
		return response.data;
	} catch (error) {
		console.log("(accountApi.js) Error while getting users by DOD: ", error);
	}
}
